import { cn } from '@/utils';
import { memo } from 'react';

import { Modal } from '..';
import { useLogic } from './define-document-preview.logic';
import { TDefineDocumentPreviewProps } from './define-document-preview.type';
import PreviewFile from './preview-file.view';

const DefineDocumentPreview = ({
	className,
	...props
}: TDefineDocumentPreviewProps) => {
	const { isLoading, imageUrls, fileList } = useLogic(props);

	return (
		<Modal
			{...props}
			title="미리보기"
			classNames={{ body: '!p-0', footer: '!m-0' }}
			className={cn('!w-[798px] min-h-screen', className)}
			labelButton="완료"
			classNameBtnContainer="mt-5 pb-5"
			onClickButton={props.onCancel}
			destroyOnClose
		>
			<PreviewFile
				isLoading={isLoading}
				imageUrls={imageUrls}
				fileName={props.title as string}
				fileList={fileList}
			/>
		</Modal>
	);
};

export default memo(DefineDocumentPreview);
